import { render, staticRenderFns } from "./no-template.vue?vue&type=template&id=594c8c8a&scoped=true&"
import script from "./no-template.vue?vue&type=script&lang=js&"
export * from "./no-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c8c8a",
  null
  
)

export default component.exports